/*eslint-disable*/
import React from "react";

// reactstrap components
import { Row, Col, Nav, NavItem, NavLink } from "reactstrap";

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <Row className="align-items-center justify-content-xl-between">
          <Col xl="6">
            <div className="copyright text-center text-xl-left text-muted">
              &copy; GPROG {new Date().getFullYear()}
              {/* <a
                className="font-weight-bold ml-1"
                href="https://myposcloud.co"
                rel="noopener noreferrer"
                target="_blank"
              >
                MyPOSCloud
              </a> */}
            </div>
          </Col>
        </Row>
      </footer>
    );
  }
}

export default Footer;